// extracted by mini-css-extract-plugin
module.exports = {"myList":"MyList_myList__2fkEA","noTitlesYet":"MyList_noTitlesYet__zAaJF"};